import { css } from 'styled-components';
import brandingRightImage from '@keyslabor/shared/assets/brandingRight.svg';
import brandingLeftImage from '@keyslabor/shared/assets/brandingLeft.svg';

export const brandedStyle = css`
  background: url(${brandingLeftImage}) left no-repeat,
    url(${brandingRightImage}) right no-repeat, white;
`;
